import { COLORS, FONTS, MEDIAS } from "./tokens";
import type { DesignMaxThemeProps } from "./types";

const theme: DesignMaxThemeProps = {
    MEDIAS,
    COLORS,
    FONTS,
} as const;

export default theme;
